module.exports = __webpack_public_path__ + "img/code-1.91dd5f9a.png";